module.exports = __webpack_public_path__ + "img/precursor-ventures-logo.e6b37e2.svg";